import { render, staticRenderFns } from "./Receipt.vue?vue&type=template&id=4672af53&"
import script from "./Receipt.vue?vue&type=script&lang=js&"
export * from "./Receipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports